import { InverterApi } from 'api/InverterApi';
import { useAppSelector } from 'app/hooks';
import { selectInverterItemSidebar } from 'components/Common/Sidebar/sidebarSlice';
import moment from 'moment';
import React, { useState } from 'react';
import { formatDataChart } from 'utils/common';
import DeviceLineChart from '../DeviceLineChart/DeviceLineChart';
import style from './DeviceGraph.module.scss';
export interface DeviceGraphProps {
  optionSelect: any;
}

export default function DeviceGraph(props: DeviceGraphProps) {
  const { optionSelect } = props;
  const inverterId = useAppSelector(selectInverterItemSidebar);
  const date = moment().format('YYYY-MM-DD');
  const [dataChart, setDataChart] = useState<any>(null);
  React.useEffect(() => {
    if (optionSelect) {
      fetchDataInverterChart(['total_out_p'], date, optionSelect);
    }
  }, [optionSelect]);

  const fetchDataInverterChart = async (arrayText: string[], date: string, optionSelect: any) => {
    const response: any = await InverterApi.fetchDataInverterGraph({
      id: inverterId,
      text: arrayText,
      start_ts: moment(date).valueOf(),
      end_ts: moment(moment(moment(date).add(1, 'days')).format('YYYY-MM-DD')).valueOf(),
      duration: 900000,
    });
    const res = await formatDataChart(response, arrayText, optionSelect);
    setDataChart(res);
  };

  return (
    <div className={style.root}>
      <div className={style.label_container}>Device graph</div>
      <div className={style.device_line_chart}>
        {optionSelect !== null && (
          <DeviceLineChart
            optionSelect={optionSelect}
            dataChart={dataChart}
            fetchDataInverterChart={fetchDataInverterChart}
          />
        )}
      </div>
    </div>
  );
}
